import type { MarketingPreferencesData } from './types'

function marketingPreferencesUseCases() {
  async function updatePreferences(formData: MarketingPreferencesData) {
    // TODO: Implement the API call to update marketing preferences
    const response = await fetch('/api/marketing-preferences', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })

    if (!response.ok) {
      throw new Error('Failed to update marketing preferences')
    }

    return response.json()
  }

  return { updatePreferences }
}

export default marketingPreferencesUseCases
